import Pristine from 'pristinejs';
import updateDonationHeaderCTA from '../modules/donation-links';
import { getInstance } from '../modules/ga4-tracking';
import AbandonmentTracking from '../modules/abandonment-tracking';
import { loadTurnstile, removeTurnstile } from '../modules/turnstile';

document.addEventListener('alpine:init', () => {
  Alpine.data('donationsNSW', (
    input,
    isPuppyPals,
    donationType,
    formNameGA,
    prefill,
    hideHandles,
    hiddenFields,
    defaultInputs,
  ) => {
    const formStepperIndex = document.querySelector('#formStepper');
    let form = null;
    let $form = null;
    let pristine = null;
    let tracking = getInstance();

    return {
      ...input,
      activeIndex: 0,
      contactType: 'mobile',
      errors: {},
      defaultInputs: defaultInputs,
      originalDonationForm: 'dFrom' in defaultInputs ? defaultInputs.dFrom : null,
      inputs: {
        sendAsGift: false,
        recipientCountrySelected: 'Australia',
        recipientState: '',
        recipientHowDidYouHear: '',
      },
      paymentObject: null,
      countryList: {
        AF: 'Afghanistan',
        AX: 'Aland Islands',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua And Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia And Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean Territory',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        CV: 'Cape Verde',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Christmas Island',
        CC: 'Cocos (Keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Congo',
        CD: 'Congo, Democratic Republic',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        CI: "Cote D'Ivoire",
        HR: 'Croatia',
        CU: 'Cuba',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        ET: 'Ethiopia',
        FK: 'Falkland Islands (Malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island & Mcdonald Islands',
        VA: 'Holy See (Vatican City State)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran, Islamic Republic Of',
        IQ: 'Iraq',
        IE: 'Ireland',
        IM: 'Isle Of Man',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KR: 'Korea',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: "Lao People's Democratic Republic",
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libyan Arab Jamahiriya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'Macedonia',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia, Federated States Of',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Netherlands',
        AN: 'Netherlands Antilles',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestinian Territory, Occupied',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        BL: 'Saint Barthelemy',
        SH: 'Saint Helena',
        KN: 'Saint Kitts And Nevis',
        LC: 'Saint Lucia',
        MF: 'Saint Martin',
        PM: 'Saint Pierre And Miquelon',
        VC: 'Saint Vincent And Grenadines',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome And Principe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia And Sandwich Isl.',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard And Jan Mayen',
        SZ: 'Swaziland',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syrian Arab Republic',
        TW: 'Taiwan',
        TJ: 'Tajikistan',
        TZ: 'Tanzania',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad And Tobago',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks And Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'United Arab Emirates',
        GB: 'United Kingdom',
        US: 'United States',
        UM: 'United States Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Viet Nam',
        VG: 'Virgin Islands, British',
        VI: 'Virgin Islands, U.S.',
        WF: 'Wallis And Futuna',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
      },
      stateList: {
        '': '',
        ACT: 'Australian Capital Territory',
        NSW: 'New South Wales',
        NT: 'Northern Territory',
        QLD: 'Queensland',
        SA: 'South Australia',
        TAS: 'Tasmania',
        VIC: 'Victoria',
        WA: 'Western Australia',
      },
      countrySelected: 'Australia',
      state: '',
      isPuppyPals: isPuppyPals,
      formName: formNameGA
        ? formNameGA
        : isPuppyPals
          ? 'GD-puppy-sponsorship-form'
          : 'GD-donation-form',
      donationType: isPuppyPals
        ? 'Monthly'
        : donationType
          ? donationType
          : 'One-off',
      donationBy: 'individual',
      contactNumberType: 'mobile',
      ballColour: '',
      paymentMethod: 'cc',
      manualEntry: true,
      ValidateStep2: {},
      ValidateStep3: {},
      donationAmount: hideHandles ? 'other' : null,
      donationAmountOther: null,
      dollarhandlesModelOnceOff: '',
      dollarhandlesModelMonthly: '',
      canRemarket: false,
      hiddenFields: hiddenFields,
      hasWalletPay : false,
      isAppeal: false,
      _errorMsg: '',
      _msg: '',
      _loading: false,

      addValidations() {
        Pristine.addValidator(
          'nsw-mobile-phone',
          (value) => {
            return /^04\d{2}\s\d{3}\s\d{3}$/.test(value);
          },
          `Please enter a valid phone number e.g. 04xxxxxxxx`,
          5,
          false,
        );
        Pristine.addValidator(
          'nsw-home-phone',
          (value) => {
            return /^\(0[1-3,5-9]\)\s\d{4}\s\d{4}$/.test(value);
          },
          `Please enter a valid landline number e.g. (02) 1234 5678`,
          5,
          false,
        );
        Pristine.addValidator(
          'nsw-international-phone',
          (value) => {
            return /^\+\d+$/.test(value);
          },
          `Please enter a valid contact number e.g. +61xxxxxxxx`,
          5,
          false,
        );
      },
      init() {
        form = document.getElementById('donationsNSW');
        $form = $(form);

        this.isAppeal = typeof form.dataset.isAppeal !== undefined;

        new AbandonmentTracking($form, 'progress-to-step-3-btn');

        this.addValidations();

        this.clearData();

        form.addEventListener('trustedFrameWalletSubmit', this.onWalletSubmit.bind(this));

        form.addEventListener('trustedFrameHasWalletPay', () => {
          this.hasWalletPay = true;
        });

        pristine = new Pristine(form);

        const alpineThis = this;

        const donateValueOther = document.querySelector('[name="other-amount"]');
        const donateValueOtherMin = document.querySelector('[data-js-other-amount-min]');
        let minimumDonationAmount = 10;

        if (donateValueOtherMin && donateValueOtherMin.getAttribute('data-js-other-amount-min')) {
          minimumDonationAmount = parseInt(donateValueOtherMin.getAttribute('data-js-other-amount-min'), 10);
        }

        pristine.addValidator(
          donateValueOther,
          (val) => {
            const frequency = $('[name="donate-frequency"]:checked').val();
            return !(frequency !== 'One-off' && val < minimumDonationAmount);
          },
          `The minimum amount for monthly donations is $${minimumDonationAmount}.`,
          5,
          false,
        );

        pristine.addValidator(
          donateValueOther,
          (val) => {
            const frequency = $('[name="donate-frequency"]:checked').val();
            return !(frequency === 'One-off' && val <= 0);
          },
          'Please enter an amount more than 0.',
          5,
          false,
        );

        // Whenever the donation frequency changes, reset the payment option back to credit card.
        this.$watch('paymentMethod', () => {
          this.createDonationOrder('[data-turnstile-2]');
        });

        this.$watch('commsField', (value, oldValue) => {
          this.commsFieldValue = value ? 1 : 0;
        });

        updateDonationHeaderCTA($form, null, 'donate', false);

        this.setPreSelectedDonationAmount(alpineThis);

        this.handlePrefill(prefill);

        this.handleHiddenFields();

        $('[name="donate-frequency"]').on('change', function () {
          alpineThis.$nextTick(() => alpineThis.setPreSelectedDonationAmount(alpineThis));
        });

        $('[name="donate-value"]').on('change', function () {
          const other = $('[name="other-amount"]');

          alpineThis.donationAmount = $(this).val();

          alpineThis.donationAmountOther = null;

          other.val('');
        });

        $('[name="other-amount"]').on('input', function () {
          const donateValue = $('[name="donate-value"]').not('[value="other"]');

          donateValue.each(function () {
            $(this).prop('checked', false);
          });
        });

        if ($('#phoneNumber').length > 0) {
          // Format the phone number as the user types it
          document
            .getElementById('phoneNumber')
            .addEventListener('keyup', (evt) => {
              var phoneNumber = document.getElementById('phoneNumber');
              phoneNumber.value = this.phoneFormat(phoneNumber.value);
            });

          document.getElementById('phoneNumber').value = this.phoneFormat(
            document.getElementById('phoneNumber').value,
          );
        }

        if ($('#mobileNumber').length > 0) {
          // Format the phone number as the user types it
          document
            .getElementById('mobileNumber')
            .addEventListener('keyup', (evt) => {
              var mobileNumber = document.getElementById('mobileNumber');
              mobileNumber.value = this.mobileFormat(mobileNumber.value);
            });

          document.getElementById('mobileNumber').value = this.mobileFormat(
            document.getElementById('mobileNumber').value,
          );
        }

        // formate name input
        if ($('.formateName').length > 0) {
          $('.formateName').on('keyup change', (evt) => {
            var inputName = this.nameFormat($(evt.target).val());
            $(evt.target).val(inputName);
          });
        }

        $('#qasaddress').on('change', (e) => {
          if ($(e.currentTarget).hasClass('qas-error')) {
            $('#qasaddress').removeClass('qas-error');
          }
        });

        $('#email').on('change', (e) => {
          this.canRemarket = pristine.validate(e.currentTarget);
        });

        this.$watch('activeIndex', () => this.$store.stepperIndex.index = this.activeIndex);
      },

      handlePrefill(prefillData) {
        Object.keys(prefillData).forEach((val) => {
          switch (val) {
            case 'donationType':
            case 'donationAmountOther':
              this[val] = prefillData[val];
              break;
            case 'donationAmount':
              this['donationAmount'] = prefillData[val];
              const donationtype =
                prefillData['donationType'] || this.donationType;
              const preSelectedHandle = $(
                `[data-js-conditional-value=${donationtype}] [value=${this['donationAmount']}]`,
              );
              preSelectedHandle.prop('checked', true);
              break;
            default:
              break;
          }
        });

        if (prefillData.step === '2') {
          this.next();
        }
      },

      handleHiddenFields() {
        [...this.hiddenFields].forEach((val) => {
          switch (val) {
            case 'address':
              $('#address-validation').hide();
              $('[data-qas-auto-fields]:not(#puppy-pals-gift)').hide();
              $('#addr-street').hide();
              $('#addr-suburb').hide();
              $('#addr-postcode').hide();
              this.countrySelected = '';
              break;
            default:
              break;
          }
        });
      },

      clearData(numberType) {
        if (numberType === 'mobile') {
          $('#mobileNumber').val('');
        } else {
          $('#phoneNumber').val('');
        }
      },

      phoneFormat(input) {
        input = input.replace(/\D/g, '');
        input = input.substring(0, 10);

        var size = input.length;
        if (size == 0) {
          input = input;
        } else if (size < 3) {
          input = '(' + input.substring(0, 2);
        } else if (size < 7) {
          input = '(' + input.substring(0, 2) + ') ' + input.substring(2, 6);
        } else {
          input =
            '(' +
            input.substring(0, 2) +
            ') ' +
            input.substring(2, 6) +
            ' ' +
            input.substring(6, 10);
        }
        return input;
      },
      mobileFormat(input) {
        input = input.replace(/\D/g, '');
        input = input.substring(0, 10);

        var size = input.length;
        if (size < 5) {
          input = input;
        } else if (size < 8) {
          input = input.substring(0, 4) + ' ' + input.substring(4, 7);
        } else {
          input =
            input.substring(0, 4) +
            ' ' +
            input.substring(4, 7) +
            ' ' +
            input.substring(7, 10);
        }
        return input;
      },
      nameFormat(input) {
        input = input.replace(/[^a-zA-ZÀ-ž\s\-\']/g, '');

        let [fistLetter, ...restLetters] = input;
        if (!fistLetter) {
          return '';
        }

        restLetters = restLetters.map(
          (val, i, arr) => i > 0 && arr[i - 1].match(/\W/) ? val : val.toLowerCase()
        );

        return fistLetter.toUpperCase() + restLetters.join('');
      },
      isMonthlyDonation(){
        return this.donationType === 'Monthly';
      },
      setPreSelectedDonationAmount(alpineThis) {
        if (this.donationType === 'One-off') {
          alpineThis.donationType = $('[name="donate-frequency"]:checked').val();
        }

        const allHandles = $('[name="donate-value"]');
        const preSelectedHandle = $(
          `[data-js-conditional-value=${alpineThis.donationType}] [data-preselected]`,
        );
        const otherHandle = $(
          `[data-js-conditional-value=${alpineThis.donationType}] [value='other']`,
        );

        if (preSelectedHandle.length) {
          preSelectedHandle.prop('checked', true); // Required for case where One-off and Monthly values are preselected
          alpineThis.donationAmount = preSelectedHandle.val();
          alpineThis.donationAmountOther = null;
        } else if (alpineThis.donationAmountOther) {
          otherHandle.length > 0 && otherHandle.prop('checked', true);
          alpineThis.donationAmount = 'other';
        } else {
          allHandles.prop('checked', false);
          alpineThis.donationAmount = null;
          alpineThis.donationAmountOther = null;
        }
      },
      loading(isLoading = true) {
        this._loading = isLoading;
      },
      error(errorMessage, errorObject = null) {
        this._errorMsg = errorMessage;
        if (errorObject) {
          console.debug(errorObject);
        }
      },
      message(message) {
        this._msg = message;
      },
      _next(dispatch) {
        this.activeIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        if (dispatch && this.activeIndex === 1) {
          dispatch('appealformfocus');
        } else {
          this.scrollTop();
        }
      },
      next(dispatch) {
        if (this.validateForm() === false) {
          this.scrollTop();
          return;
        }

        this.setTrackingCookie();

        const newIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        if (newIndex === 2) {
          this.createDonationOrder();
        } else {
          this._next(dispatch);
        }
      },
      setTrackingCookie() {
        this.setCookie(
          this.formName,
          this._get_donation_amount(),
          this.donationType,
        );
      },
      setCookie(form, amount, frequency) {
        // Only set cookie if all values are present
        if (form && amount && frequency) {
          document.cookie = `campaign=${form};path=/`;
          document.cookie = `campaign-amount=${amount};path=/`;
          document.cookie = `campaign-frequency=${frequency};path=/`;
          document.cookie = `campaign-source=${window.location.href};path=/`;
        }
      },
      onWalletSubmit(event) {
        const PayWayData = event.detail;

        const extraData = {
          'trustedframe_token': PayWayData.singleUseTokenId,
          'payment-method': PayWayData.walletType,
        };

        this.loading();

        loadTurnstile(
          $form.find('[data-turnstile-2]')[0],
          (token, turnstileID) => {
            this._submitPayment($form, extraData)
              .then(this._paymentSuccess.bind(this))
              .catch(this._paymentError.bind(this))
              .finally(() => {
                removeTurnstile(turnstileID);
              });
          },
          'donate-nsw-2',
          false,
        );



      },
      onPaymentsubmit() {
        this.scrollTop();

        if (this.validateForm() === false) {
          return;
        }
        this.loading();
        this.paymentObject.trustedFrameGenerateToken((err, data) => {
          if (err) {
            let errMessage = err.message;

            if (err.status == 422) {
              errMessage = 'Invalid payment data received. ';

              if (this.paymentMethod === 'bank') {
                errMessage +=
                  'Please check you have added an Account Name, BSB and Account Number.';
              } else {
                errMessage +=
                  'Please check you have completed all the payment fields including the Security Code and Expiration date.';
              }
            } else if (!errMessage) {
              errMessage = 'Something went wrong processing your payment.';
            }

            this.error(errMessage, err);

            this.sentryError(errMessage, err);

            tracking.createEvent('form-event', 'form_error', form);

            this.loading(false);
            return false;
          }

          loadTurnstile(
            $form.find('[data-turnstile-2]')[0],
            (token, turnstileID) => {
              this._submitPayment($form)
                .then(this._paymentSuccess.bind(this))
                .catch(this._paymentError.bind(this))
                .finally(() => {
                  removeTurnstile(turnstileID);
                });
            },
            'donate-nsw-2',
            false,
          );
        });
      },
      _paymentSuccess(response) {
        this.message('Redirecting...');

        document.dispatchEvent(new CustomEvent('GDdonationSuccess', { detail: response.payload }));

        tracking.createEvent('form-event', 'form_submit', form);
        let params = '?type=' + response.payload.recurrence;
        const thankYouPages = {
          oneOff: '/thank-you-one-off/',
          monthly: '/thank-you-monthly/',
          puppyPal: '/thank-you-puppy-pal/',
          currentCampaign: '/thank-you-current-campaign/',
        };
        let thankYouPage =
          response.payload.recurrence === 'monthly'
            ? thankYouPages.monthly
            : thankYouPages.oneOff;
        if (response.payload.litter_name) {
          params += '&litter_name=' + response.payload.litter_name;
          thankYouPage = thankYouPages.puppyPal;
        }
        if (this.formName === 'GD-current-campaign') {
          thankYouPage = thankYouPages.currentCampaign;
        }
        if (response.payload.donottrack) {
          params += '&dnt=on';
        }
        if (this.originalDonationForm) {
          params += '&dfrom=' + this.originalDonationForm;
        }

        if (response.payload.thank_you_page) {
          thankYouPage = response.payload.thank_you_page;
        }

        window.top.location = thankYouPage + params;
      },
      _paymentError(err) {
        if (err.status === 'error_fields') {
          this.errors = err.payload; //Payload is a list of fields with errors
          this.loading(false);
        } else {
          this.error(
            err.payload && typeof err.payload === 'string'
              ? err.payload
              : 'We encountered a problem, please check your details and try again.',
            err,
          );
          this.loading(false);
        }
      },
      _add_default_inputs(ajaxData) {
        Object.keys(this.defaultInputs).forEach((key) => {
          ajaxData.push({ name: key, value: this.defaultInputs[key] });
        });

        ajaxData.push({ name: 'formName', value: this.formName });

        return ajaxData;
      },
      _submitPayment($form, extraData = {}) {
        return new Promise((resolve, reject) => {
          const ajaxData = this._add_default_inputs($form.serializeArray());

          ajaxData.push({ name: 'action', value: 'donation_submit_payment' });

          Object.keys(extraData).forEach((key) => {
            const existingKey = ajaxData.findIndex((item) => item.name === key);
            if (existingKey !== -1) {
              ajaxData[existingKey].value = extraData[key];
            } else {
              ajaxData.push({ name: key, value: extraData[key] });
            }
          });

          $.post(guidedogsGlobals.ajaxurl, ajaxData, function (response) {
            if (response && response.status === 'OK') {
              resolve(response);
            } else {
              reject(response);
            }
          }).fail(reject);
        });
      },
      prev(dispatch) {
        this.activeIndex = Math.max(this.activeIndex - 1, 0);

        this.errors = {};

        if (dispatch && this.activeIndex === 0) {
          dispatch('appealcontentfocus');
        } else {
          this.scrollTop();
        }
      },
      scrollTop() {
        $('html, body').animate(
          {
            scrollTop:
              $('#formStepper').offset().top - $('#header').outerHeight(),
          },
          150,
        );
        this.$nextTick(() => this.focusFirstField());
      },
      focusFirstField() {
        const errorMessage = $form.find('[data-js-donation-errors] a').get(0);
        // find invalid fields first, then just first field
        const firstField =
          $form
            .find('input, select, textarea')
            .filter('[aria-invalid="true"]:visible')
            .get(0) ||
          $form.find('input, select, textarea').filter(':visible').get(0);
        if (errorMessage) {
          errorMessage.focus();
        } else if (firstField) {
          firstField.focus();
        }
      },
      createDonationOrder(turnstileContainer = '[data-turnstile-1]') {
        this.error('');
        this.hasWalletPay = false;
        this.loading();
        this._addVarHiddenFields({
          final_amount: this._get_donation_amount(),
        });
        loadTurnstile(
          $form.find(turnstileContainer)[0],
          (token, turnstileID) => {
            this._createDonationOrder($form)
              .then((response) => {
                this._addConsHiddenFields({
                  order_id: response.payload.order_id,
                });

                $form
                  .find('[trustedframe-iframe]')
                  .html(response.payload.trustedFrame);

                this.paymentObject = new GDTrustedFrame(response.payload.formId, response.payload.apiKey, this.isAppeal);

                this.paymentObject.triggerTrustedFrame({
                  type: this.paymentMethod,
                  principalAmount: this._get_donation_amount(),
                  useWallet: !this.isMonthlyDonation(),
                  googleMerchantId: response.payload.gMerchantId,
                  walletContainer: 'GDwalletFrame',
                });

                this._next();
              })
              .catch((err) => {
                if (err.status === 'error_fields') {
                  if (
                    err.payload.street !== undefined &&
                    err.payload.street === 'Please enter a valid address'
                  ) {
                    $('#qasaddress').addClass('qas-error');
                  }
                  this.errors = err.payload; //Payload is a list of fields with errors
                  this.scrollTop();
                } else {
                  this.error(
                    err.payload && typeof err.payload === 'string'
                      ? err.payload
                      : 'Something went wrong in the process, please check your inputs and try again',
                    err,
                  );

                  this.sentryError('error create donation order', err);
                }
              })
              .finally(() => {
                removeTurnstile(turnstileID);
                this.loading(false);
              });
          },
          'donate-nsw-1',
          false,
        );
      },
      manualAddressEntry() {
        this.manualEntry = true;
      },
      validateForm() {
        // Reset errors initially.
        this.errors = {};
        this.error('');
        this.message('');

        // Grab all visible elements on the current step.
        const $currentStepElements = $(
          'input:not(:hidden), select:not(:hidden), texarea:not(:hidden)',
          '.donate-form__step.is-active',
        );

        let valid = pristine.validate($currentStepElements);

        // Go through each of the elements and find out if they have errors.
        $currentStepElements.each((i, el) => {
          const individualErrors = pristine.getErrors(el);

          let hasError = individualErrors && individualErrors.length > 0;

          el.setAttribute('aria-invalid', hasError);

          if (hasError) {
            // Only push for unique fields (prevents multiple errors for radio)
            if (!this.errors[el.getAttribute('name')]) {
              tracking.createEvent('form-event', 'form_error', el);
            }

            this.errors[el.getAttribute('name')] = individualErrors[0];
          }
        });

        return valid;
      },
      _addConsHiddenFields(objFields, _$form = false) {
        if (!_$form) _$form = $form;
        if (_$form.find('.consHiddenFields').length <= 0)
          _$form.prepend('<div class="consHiddenFields"></div>');

        const $hiddenContainer = _$form.find('.consHiddenFields');

        let $field;
        Object.keys(objFields).forEach((key) => {
          $field = $hiddenContainer.find('[name="' + key + '"]');
          if ($field.length > 0) {
            $field.val(objFields[key]);
          } else {
            $hiddenContainer.append(
              '<input type="hidden" name="' +
              key +
              '" value="' +
              objFields[key] +
              '">',
            );
          }
        });
      },
      _addVarHiddenFields(objFields, _$form = false) {
        if (!_$form) _$form = $form;
        if (_$form.find('.varHiddenFields').length <= 0)
          _$form.prepend('<div class="varHiddenFields"></div>');

        const $hiddenContainer = _$form.find('.varHiddenFields');

        $hiddenContainer.html('');

        Object.keys(objFields).forEach((key) => {
          $hiddenContainer.append(
            '<input type="hidden" name="' +
            key +
            '" value="' +
            objFields[key] +
            '">',
          );
        });
      },
      _get_donation_amount() {
        let amount = this.donationAmount;

        if (
          !isNaN(this.donationAmountOther) &&
          parseInt(this.donationAmountOther, 10) > 0
        ) {
          amount = this.donationAmountOther;
        }

        amount = parseFloat(amount);

        if (isNaN(amount)) {
          amount = 0;
        }

        return amount;
      },
      displayQuantity() {
        const formatter = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
        });

        return formatter.format(this._get_donation_amount());
      },
      _createDonationOrder(_$form) {
        return new Promise((resolve, reject) => {
          const ajaxData = this._add_default_inputs(_$form.serializeArray());

          ajaxData.push({ name: 'action', value: 'create_donation_order' });

          $.post(guidedogsGlobals.ajaxurl, ajaxData, function (response) {
            if (response && response.status === 'OK') {
              resolve(response);
            } else {
              reject(response);
            }
          }).fail(reject);
        });
      },
      sentryError(message, extraContext) {
        try {
          window.captureSentryError(message, extraContext);
        } catch (err) {
          console.log('Sentry is not available.');
        }
      },
    };
  });
});



class GDTrustedFrame {

  form_id = null;
  api_key = null;
  is_appeal = false;


  constructor(form_id, api_key, is_appeal = false) {
    this.form_id = form_id;
    this.api_key = api_key;
    this.is_appeal = is_appeal;
  }

  triggerTrustedFrame(options = {
    type: 'cc',
    principalAmount: null,
    useWallet: false,
    googleMerchantId: null,
    walletContainer: ''
  }) {

    if ( typeof window.payway === "undefined" ) {
      const script = document.createElement( 'script' );
      script.onload = () => { this.triggerTrustedFrame(options) };
      script.src = 'https://api.payway.com.au/rest/v1/payway.js';
      document.head.appendChild( script );
      return false;
    }

    if ( window.trustedFrame ) {
      window.trustedFrame.destroy();
    }

    const $target = $( '#' + this.form_id );
    let frameCall = 'createCreditCardFrame';

    if ( options.type === 'bank' ) {
      frameCall = 'createBankAccountFrame';
    }

    const paywayArgs = {
      publishableApiKey: this.api_key,
      container: this.form_id,
      tokenMode: 'callback',
      layout: 'narrow',
      style: this.TF_get_iframe_styles( options.type ),
      currency: 'aud',
      onValid: () => {
        this.eventTriggerTrustedFrame( $target, 'Valid' );
      },
      onInvalid: () => {
        this.removeHiddenDataTF();
        this.eventTriggerTrustedFrame( $target, 'Invalid' );
      }
    };

    const walletFields = {
      ...paywayArgs,
      ...{
        googleMerchantId: options.googleMerchantId,
        buttonMode: 'callback',
        principalAmount: options.principalAmount,
        container: options.walletContainer
      }
    };

    window.payway[frameCall]( paywayArgs, ( err, frame ) => {
      if(!err){
        window.trustedFrame = frame;
        this.eventTriggerTrustedFrame( $target, 'Loaded' ); //triggers a trustedFrameLoaded event
      }
    } );

    this.resetWalletPayment(walletFields);

    if (options.useWallet) {
      this.loadWalletPayments(walletFields, $target);
    }

  }

  resetWalletPayment(paymentOptions){
    const walletFrame = document.getElementById(paymentOptions.container);

    // Avoid addid duplicate buttons
    if (walletFrame.children.length > 0) {
      while (walletFrame.firstChild) {
        walletFrame.removeChild(walletFrame.lastChild);
      }
    }
  }

  loadWalletPayments(paymentOptions){

    const walletFrame = document.getElementById(paymentOptions.container);

    window.payway.createPaymentRequestButton( paymentOptions, ( err, data ) => {

      if (err) {
        try {
          sentry('nswWalletError', err.message, data);
        } catch (err) {
          console.log('Sentry is not available.');
        }
      } else{
        this.eventTriggerTrustedFrame( $( '#' + this.form_id ), 'WalletSubmit', data );
      }
    } );

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {

        if (mutation.type === 'childList') {

          const apayButton = walletFrame.querySelector('[class*="apple-pay"]');

          const gpayButton = walletFrame.querySelector('.gpay-button');
          // We do this because the gpay button from payway comes with hardcoded classes
          if (gpayButton) {
            const label = document.createElement('span');
            label.classList.add('u-visuallyhidden');
            label.innerHTML = 'Donate with Google Pay';
            gpayButton.appendChild(label);

            gpayButton.classList.remove('plain');
            gpayButton.classList.add('donate');
          }

          if (gpayButton || apayButton) {
            this.eventTriggerTrustedFrame( $(mutation.target), 'HasWalletPay' );
          }

          observer.disconnect();
        }
      });
    });

    // Configure the observer to look for child elements being added
    const config = { childList: true, subtree: true };
    observer.observe(walletFrame, config);


  }

  trustedFrameGenerateToken( callback ) {
    if ( !window.trustedFrame ) return false;

    const trustedFrameTokenCallback = ( err, data ) => {
      if ( err ) {
        this.removeHiddenDataTF();
      } else {
        this.fillHiddenDataTF( data );
      }

      if ( typeof callback === 'function' ) callback( err, data );
    };

    window.trustedFrame.getToken( trustedFrameTokenCallback );
  }

  fillHiddenDataTF( data ) {
    $( "input[name='trustedframe_token']" ).first().val( data.singleUseTokenId );
  }

  removeHiddenDataTF() {
    $( "input[name^='trustedframe']" ).val( '' );
  }

  eventTriggerTrustedFrame( $target, name, data = null ) {

    /* Trigger loaded event */
    const event = new CustomEvent( 'trustedFrame' + name, {
      bubbles: true,
      detail: data
    } );
    $target.get( 0 ).dispatchEvent( event );
    $target.trigger( 'trustedFrame' + name, [data] );
  }

  TF_get_iframe_styles(type = 'cc'){
    let weakSelector = '.payway-card';

    if (type === 'bank') {
      weakSelector = '.payway-account';
    }

    const mainSelector = 'div'+weakSelector;
    const styles = {};

    styles['.payway-creditcard, .payway-bankaccount'] = {
      // 'max-width': '400px',
      'margin': 'auto'
    };

    styles[mainSelector+' *'] = {
      'box-sizing': 'border-box'
    };
    styles[weakSelector] = {
      'display': '-ms-flexbox',
      '-ms-flex-wrap': 'wrap'
    };

    styles['body '+weakSelector] = {
      'display': '-webkit-box'
    };

    styles[mainSelector] = {
      'background': 'none',
      'border-width': 0,
      'width': 'auto!important',
      'height': 'auto!important',
      'display': 'flex',
      'flex-wrap': 'wrap',
      'margin-left': '-15px',
      'margin-right': '-15px',
      'justify-content': 'space-between'
    };
    styles[mainSelector+' label'] = {
      'font-size': '16px',
      'margin-bottom': '15px',
      'color': '#282829',
      'line-height': '1.35',
      'font-family': 'canada-type-gibson,sans-serif',
      'display': 'block',
      'width': '100%',
      'height': 'auto',
      'position': 'static!important',
      'padding': '0px 15px',
      'font-weight': '700'
    };
    styles[mainSelector+' legend'] = {
      'font-size': '16px;',
      'margin-bottom': '8px',
      'color': '#282829',
      'font-family': 'canada-type-gibson,sans-serif',
      'font-weight': '700'
    };
    styles[mainSelector+' input'] = {
      'color': '#282829',
      'border': '2px solid #e9e9e7',
      'background-color': this.is_appeal ? '#fff' : '#f6f6f8',
      'font-size': '20px',
      'transition': 'border 0.3s cubic-bezier(0.4,0,0,1)',
      'line-height': '1.5em !important',
      'position': 'static!important',
      'display': 'block',
      'border-radius': '0px',
      'width': '100%',
      'padding': '15px 20px',
      'height': '64px'
    };

    styles[mainSelector+' label input'] = {
      'margin-top': '8px'
    };

    styles[mainSelector+' label.payway-number input.payway-hidden'] = {
      'position': 'absolute!important',
      'pointer-events': 'none',
    };
    styles[mainSelector+' label.payway-number input'] = {
      'width': '100%',
    };
    styles[mainSelector+' label.payway-csc input, '+mainSelector+'-style label.payway-csc input'] = {
      'width': '7rem'
    };
    styles[mainSelector+' .payway-expiration .payway-month, '+mainSelector+' .payway-expiration .payway-year'] = {
      'display': 'inline-block',
      'height': '4em',
    };
    styles[mainSelector+' select'] = {
      'color': '#432a18',
      'border': '2px solid #e9e9e7',
      'background-color':  this.is_appeal ? '#fff' : '#f6f6f8',
      'font-size': '20px',
      'transition': 'border 0.3s cubic-bezier(0.4,0,0,1)',
      'line-height': '1.5em !important',
      'position': 'static!important',
      'display': 'block',
      'border-radius': '0px',
      'width': '100%',
      'padding': '15px 20px',
      'height': '64px'
      /*
      '-moz-appearance': 'none',
      '-webkit-appearance': 'none',
      'appearance': 'none'
      */
    };
    styles[mainSelector+' .payway-expiration'] = {
      'order': '2',
      'position': 'static',
      'padding': '0 15px',
      'width': 'auto',
      'height': 'auto'
    };
    styles[mainSelector+' .payway-expiration select'] = {
      'font-size': '0.75em'
    };
    styles[mainSelector+' .payway-creditcard-expirationseparator'] = {
      'display': 'none !important'
    };
    styles[mainSelector+' .payway-creditcard-testfacility, div.payway-account-testfacility'] = {
      'left': 'auto',
      'right': '1.5em',
      'border': 'none',
      'background': 'none'
    };
    styles[mainSelector+' .payway-type-read-only'] = {
      'display': 'none !important'
    };
    styles[mainSelector+' .payway-expiration .payway-year'] = {
      'width': 'auto',
      'right':'-1.5em'
    };
    styles[mainSelector+' .payway-expiration .payway-month'] = {
      'width': 'auto',
      'margin-right': '5px'
    };
    styles[mainSelector+' label.payway-name'] = {
      'order': '0',
      'width': '100%'
    };
    styles[mainSelector+' label.payway-number'] = {
      'width': '100%',
      'order': 1
    };
    styles[mainSelector+' label.payway-csc'] = {
      'order': '3',
      'text-align':'left',
      'width': 'auto'
    };
    styles[mainSelector+' label.payway-csc input'] = {
      'font-size': '1em'
    };
    styles[mainSelector+' label.payway-cscpayway-js-enabled'] = {
      'padding':'0px'
    };
    styles[mainSelector+' .payway-account'] = {
      'background': 'none',
      'border': 'none',
      'width': '100%',
    };
    styles[mainSelector+' .payway-account-form'] = {
      'width': '100%',
    };
    styles[mainSelector+' label.payway-bsb'] = {
      'width': '100%',
    };
    styles[mainSelector+' label.payway-account-number'] = {
      'width': '100%',
    };
    styles[mainSelector+' .payway-account-name-input'] = {
      'width': '100%',
    };
    styles[mainSelector+' .payway-account-name-input::placeholder'] = {
      'color': 'rgb(246, 246, 248)',
      'opacity': '0',
    };
    styles[mainSelector+' .payway-account-number-input'] = {
      'width': '100%',
    };
    styles[mainSelector+' input:hover'] = {
      'border' : '2px solid #a7a7a9;',
    };
    styles[mainSelector+' input:focus'] = {
      'border' : '2px solid #ff6e33',
    };

    styles[mainSelector+' select:hover'] = {
      'border' : '2px solid #a7a7a9;',
    };
    styles[mainSelector+' select:focus'] = {
      'border' : '2px solid #ff6e33',
    };

    styles['input.payway-complete, select.payway-complete, fieldset.payway-complete select, fieldset.payway-complete input'] = {
      'border': '2px solid green!important'
    }

    styles['div.payway-card .payway-expiration .payway-month, div.payway-card .payway-expiration .payway-year'] = {
      'width': 'auto',
      'font-size': 'inherit',
      'padding': '15px 20px',
      'display': 'inline-block'
    };

    styles['div.apple-pay-button-with-text'] = {
      '-apple-pay-button-type': 'donate',
    };

    return styles;
  }

}
